module.exports = __webpack_public_path__ + "static/media/arrow-is-wrong.f79c231e.mp3";